import { IconButton, IconName } from '@optimus-web/core';
import { useDeleteServiceProductDialog } from '../../hooks/useDeleteServiceProductDialog';

interface Props {
    enterpriseProductId: string;
    productId: string;
}
export const DeleteServiceProductButton = ({ enterpriseProductId, productId }: Props) => {
    const { confirmationDialog, openConfirmationDialog } = useDeleteServiceProductDialog({
        productIds: [productId],
        currentEnterpriseId: enterpriseProductId,
    });

    return (
        <>
            <IconButton icon={IconName.Delete} type="button" onClick={openConfirmationDialog} size="small" />
            {confirmationDialog}
        </>
    );
};
